
<!--button mat-raised-button color="primary" (click)="search()">Lookup Postcode <fa-icon matSuffix [icon]="faSearch" ></fa-icon></button-->


<button type="button" class="btn btn-success" (click)="search()">
  <fa-icon [icon]="faSearch"></fa-icon> Lookup Postcode
</button>

